import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy border-t border-white/10 py-8 px-4 text-center" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <p className="text-brand-cream/50 text-sm mb-4" data-id="element-43">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-brand-cream/40 text-sm" data-id="element-44">
          &copy; {new Date().getFullYear()} RESET DIGITAL. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}